var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCameraUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.333 31.667A3.333 3.333 0 0135 35H5a3.333 3.333 0 01-3.333-3.333V13.333A3.333 3.333 0 015 10h6.667L15 5h10l3.333 5H35a3.333 3.333 0 013.333 3.333v18.334z",
    stroke: "#B0B0B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.333A6.667 6.667 0 1020 15a6.667 6.667 0 000 13.333z",
    stroke: "#B0B0B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgCameraUpload;